"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLIENT = 'API_FETCH__CLIENT';
exports.CLIENT_COUNTRY = 'API_FETCH__CLIENT_COUNTRY';
exports.SET_CLIENT_DATA = 'CLIENT__SET_CLIENT_DATA';
exports.SET_CLIENT_COUNTRIES = 'CLIENT__SET_CLIENT_COUNTRIES';
//# sourceMappingURL=action-types.js.map